import { DATE_AND_TIME_FORMAT_SHORT } from '../AppConstants';
import type { LoggerId, LoggerStatus } from '../types/Logger';
import { formatDateTime } from './FormattingHelpers';

export function getTemperatureLoggerStatusMessage(loggerStatus: LoggerStatus): string {
    const temperatureTime = loggerStatus.details?.timestamp
        ? formatDateTime(loggerStatus.details.timestamp, DATE_AND_TIME_FORMAT_SHORT)
        : 'N/A';
    return loggerStatus.details ? `${loggerStatus.message} at ${temperatureTime}` : loggerStatus.message;
}

/**
 * Creates a LoggerId from a validated ID string.
 * Only call after validation passes.
 */
export const createLoggerId = (validatedId: string): LoggerId => {
    return validatedId as LoggerId;
};
